/**
 * React 16 compatibility: `react/jsx-runtime` exists only in React 17+.
 * `@vitejs/plugin-react` still requests this module for optimizeDeps / tooling.
 */
import * as React from 'react';

export const { Fragment } = React;

function createFromJsx(type, props, key, staticChildren) {
  const { children, ...config } = props == null ? {} : props;
  if (key !== undefined && key !== null) {
    config.key = key;
  }

  // Static children (the `jsxs` path) are compile-time-known and don't need keys.
  // Spreading them as variadic args to `createElement` marks each child validated,
  // matching the real automatic runtime and the classic JSX transform. Dynamic
  // lists come through `jsx` (a single array child) and stay in props so React can
  // still warn about genuinely missing keys.
  if (staticChildren && Array.isArray(children)) {
    return React.createElement(type, config, ...children);
  }
  if (children !== undefined) {
    config.children = children;
  }
  return React.createElement(type, config);
}

export function jsx(type, props, key) {
  return createFromJsx(type, props, key, false);
}

export function jsxs(type, props, key) {
  return createFromJsx(type, props, key, true);
}
